import { Component, computed, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import moment from 'moment-timezone';
import { SiIconComponent } from '@siemens/element-ng/icon';
import type { ILocation } from '../../../../../shared/interfaces/ILocation';
import { LocationService } from '../../../services/location.service';

@Component({
    selector: 'app-tab-location-info',
    templateUrl: './tab-location-info.component.html',
    styleUrls: ['./tab-location-info.component.scss'],
    imports: [TranslatePipe, SiIconComponent, DatePipe]
})
export class TabLocationInfoComponent {
    private readonly locationService = inject(LocationService);
    private readonly translate = inject(TranslateService);

    public readonly location = input.required<ILocation>();
    public readonly primaryWebsiteUrl = computed(() => {
        const websiteUrls = this.location().websiteUrls ?? [];
        const primaryUrl = websiteUrls.find(url => url.typeNumber === 1);

        return primaryUrl ?? websiteUrls[0];
    });
    public readonly countryName = computed(() => {
        const value = this.location();
        if (this.translate.currentLang() === 'de') {
            return value.country?.name;
        }
        return value.country?.isoName;
    });
    public readonly localTime = computed(() => this.getLocalTime());

    private getLocalTime(): string {
        const value = this.location();
        if (!value.gps) {
            return 'N/A';
        }

        const latlong = value.gps.split(',');
        const result = latlong.map((entry: string) => {
            const matches = entry.match(/[+-]?\d+(\.\d+)?/g);
            if (!matches?.length) {
                return NaN;
            }
            const coordinate = Number.parseFloat(matches[0]);
            return entry.match('[WS]') ? -coordinate : coordinate;
        });

        if (result.length < 2 || Number.isNaN(result[0]) || Number.isNaN(result[1])) {
            return 'N/A';
        }

        const timezone = this.locationService.getTimeZoneFromCoordinates(result[0], result[1]);
        return moment().tz(timezone).format('HH:mm');
    }
}
